import React from "react";
import {odxIconSets, odxVariants} from "../constants";
import OdxIcon from "./Odx-Icon";

interface OdxChipProps {
    removable?: boolean;
    size: "small" | "medium" | "large";
    variant?: odxVariants;
    content: string;
    contentAddional?: string;
    onRemove?: () => void;
    truncateText?: boolean;
    id?: string
}

/**
 * Chip component
 * @param removable Show a X button to remove the chip
 * @param size Size of the chip
 * @param variant Variant of the chip, "secondary" as default
 * @param content Text displayed on the chip
 * @param contentAddional Additional text in a new line
 * @param truncateText Truncate the text if it is too long, default is false
 * @param onRemove Callback function when the remove button is clicked
 * @constructor
 */
const OdxChip: React.FC<OdxChipProps> = ({
                                             removable = false,
                                             size,
                                             variant = odxVariants.secondary,
                                             content,
                                             contentAddional,
                                             truncateText = false,
                                             onRemove,
                                             id
                                         }) => {
    return (
        <div className={`odx-chip--${size} odx-chip--${variant} odx-chip`}>
            <div id={"OdxChip_" + id} className={truncateText ? `truncate max-w-[380px]` : 'max-w-[380px]'}>
                {content}
                {contentAddional && <div>{contentAddional}</div>}
            </div>
            {removable && (
                <button
                    type="button"
                    onClick={onRemove}
                    id={"OdxChip_" + id + "_RemoveBtn"}
                >
                    <OdxIcon name={"close"} size={"sm"} iconSet={odxIconSets.core}/>
                </button>
            )}
        </div>
    );
};

export default OdxChip;